const reactSelectStyles = {
  control: (base: any) => ({
    ...base,
    minHeight: 50,
    borderRadius: 10,
  }),
};
export default reactSelectStyles;
